<template>
  <v-row no-gutters>
    <v-col cols="12" :class="$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5'">
      <v-form ref="editWhatsappForm">
        <app-form-field
          :enabledLabel="true"
          v-model.trim="whatsappInfo.whatsapp"
          :label="$t(`field.whatsapp`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.whatsappRules()"
        ></app-form-field>
        <v-row no-gutters class="pb-10">
          <v-col cols="12">
            <app-button class="dialog-button" :action="this.submit" :title="$t(`button.submit`)"></app-button>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { formValidator, errorCodeHelper, locale } from '@/util'
import { MEMBER_UPDATE_DETAIL } from '@/store/member.module'

export default {
  name: 'profileEditWhatsapp',
  mounted() {
    this.$refs.editWhatsappForm.reset()
  },
  props: {
    closeAction: {
      type: Function,
      required: true,
      default: () => {}
    },
    personalInfo: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    validator: formValidator,
    whatsappInfo: {
      whatsapp: ''
    }
  }),
  created() {
    this.whatsappInfo.whatsapp = this.personalInfo.whatsapp?.value || ''
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    updateDetailResponseComplete() {
      return this.$store.state.member.updateDetailResponse.complete
    }
  },
  watch: {
    updateDetailResponseComplete() {
      let response = this.$store.state.member.updateDetailResponse
      if (response.complete) {
        if (response.code !== 0 && !response.success) {
          this.$parent.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
        } else {
          this.$parent.$parent.openAlert(true, locale.getMessage(`message.memberPersonalDetailUpdated`))
          this.closeAction()
        }
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.editWhatsappForm.validate()) {
        let memberObj = {
          whatsapp: this.whatsappInfo.whatsapp
        }
        this.$store.dispatch(`${MEMBER_UPDATE_DETAIL}`, { memberObj })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-button {
  width: 100%;
  text-transform: capitalize;
  border-radius: 10px;
}
</style>
